import Typography from "@crm/components/typography";
import styled from "styled-components";

const ExtraServicesPriceLabel = styled(Typography)`
  ${({theme}) => theme.breakpoints.down('mobileM')} {
    font-size: 10px;
  }

  ${({theme}) => theme.breakpoints.down('mobile')} {
    font-size: 12px;
  }
`;

export default ExtraServicesPriceLabel